import { render, staticRenderFns } from "./VclTable.vue?vue&type=template&id=e478eb50&scoped=true&lang=pug&"
import script from "./VclTable.vue?vue&type=script&lang=js&"
export * from "./VclTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e478eb50",
  null
  
)

export default component.exports